import React, { useMemo, useState } from "react";
import {
  useElements,
  useStripe,
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
} from "@stripe/react-stripe-js";
import { Alert, Modal, Row, Col, Form } from "react-bootstrap";
import { toastMessage, monthWithPrefix } from "../../../Common/Common";
import * as code from "../../../../config/Constants";
const useOptions = () => {
  const options = useMemo(() => ({
    style: {
      base: {
        color: "#424770",
        letterSpacing: "0.025em",
        fontFamily: "Roboto, sans-serif",
        border: "1px solid #d2d2d2",
        padding: "5px 10px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#9e2146",
      },
    },
  }));

  return options;
};

const CheckoutForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();
  const options = useOptions();
  const [cardNumber, setcardNumber] = useState(
    props.getUserData().paymentMethods.number
  );
  const [brand, setBrand] = useState(props.getUserData().paymentMethods.brand);
  const [expireMonth, setExpireMonth] = useState(
    props.getUserData().paymentMethods.expireMonth
  );
  const [expireYear, setExpireYear] = useState(
    props.getUserData().paymentMethods.expireYear
  );
  const [currentCard, setCurrentCard] = useState(true);
  const [currentMonth, setCurrentMonth] = useState(true);
  const [cvv, setCurrentCvv] = useState(true);

  const handleSubmit = async (event) => {
    props.updateUserData("showLoader", true);
    // Block native form submission.
    event.preventDefault();
    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardNumberElement);
    if (
      currentCard == false &&
      currentMonth == false &&
      cvv == false &&
      cardNumber !== ""
    ) {
      // Use your card Element with other Stripe.js APIs
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
      });

      if (error) {
        toastMessage(code.ERROR, error.message);
        props.updateUserData("showLoader", false);
      } else {
        props.getPaymentData(paymentMethod);
        props.updateUserData("showLoader", false);
        props.nextButtonClick();
      }
    } else if (
      currentCard == false &&
      currentMonth == false &&
      cvv == false &&
      cardNumber === ""
    ) {
      // Use your card Element with other Stripe.js APIs
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
      });

      if (error) {
        toastMessage(code.ERROR, error.message);
        props.updateUserData("showLoader", false);
      } else {
        props.getPaymentData(paymentMethod);
        props.updateUserData("showLoader", false);
        props.nextButtonClick();
      }
    } else if (
      currentCard == true &&
      currentMonth == true &&
      cvv == true &&
      cardNumber !== ""
    ) {
      props.nextButtonClick();
      props.updateUserData("showLoader", false);
    } else {
      toastMessage(code.ERROR, "Please enter card details");
      props.updateUserData("showLoader", false);
    }
  };

  return (
    <div className="step-content">
      <Row>
        <Col xs={12}>
          <h4 className="title-blue mb-3">
            {cardNumber !== "" && !!cardNumber
              ? "Current Card Details"
              : "Card Details"}
          </h4>
        </Col>
      </Row>
      {cardNumber !== "" && !!cardNumber && (
        <>
          <Row>
            <Col xs={12} sm={4}>
              <Form.Group controlId="">
                <Form.Label>Card Number: {"****" + cardNumber}</Form.Label>
              </Form.Group>
            </Col>
            <Col xs={12} sm={4}>
              <Form.Group controlId="">
                <Form.Label>Brand: {brand}</Form.Label>
              </Form.Group>
            </Col>
            <Col xs={12} sm={4}>
              <Form.Group controlId="">
                <Form.Label>
                  Expiry: {monthWithPrefix(expireMonth) + "/" + expireYear}
                </Form.Label>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <h4 className="title-blue mb-3">
                Change Card Details{" "}
                <small>
                  (Enter new card details and click next if you want to change
                  current card details)
                </small>
              </h4>
            </Col>
          </Row>
        </>
      )}

      <form onSubmit={handleSubmit} className="form-sm">
        <Row>
          <Col md={6}>
            <label>Card Number</label>
            <CardNumberElement
              options={options}
              onChange={(event) => {
                setCurrentCard(event.empty);
              }}
            />
          </Col>

          <Col md={3}>
            <label>Expiry</label>
            <CardExpiryElement
              options={options}
              onChange={(event) => {
                setCurrentMonth(event.empty);
              }}
            />
          </Col>

          <Col md={3}>
            <label>CVC</label>
            <CardCvcElement
              options={options}
              onChange={(event) => {
                setCurrentCvv(event.empty);
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col className="text-right">
            <button
              variant="primary"
              size="sm"
              className="btn btn-sm btn-primary btn-blue btn-outlined w-140 mr-3"
              style={{ marginTop: 20, marginLeft: 20 }}
              onClick={(e) => {
                e.preventDefault();
                props.perviousButtonClick();
              }}
              disabled={!stripe}
              tabIndex="-1"
            >
              Previous
            </button>
            <button
              variant="primary"
              size="sm"
              className="btn btn-sm btn-primary btn-blue w-140 saveBtn"
              style={{ marginTop: 20, marginLeft: 20 }}
              type="submit"
              disabled={!stripe}
              tabIndex="-1"
            >
              Next
            </button>
          </Col>
        </Row>
      </form>
    </div>
  );
};
export default CheckoutForm;
